export { DesignCategories } from './DesignCategories';
export * from './useCategoriesConfig';
